import React from "react";

export default function GtmWhyMatters() {
  return (
    <div className="about_area pt-45">
      <div className="container">
        <div className="row">
          
             {/* Image Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="about_thumb about-page">
              <img src="/assets/images/about/gtm-assessment.png" alt="Data Intelligence Company" />
            </div>
          </div>
          
          {/* Text Content Section */}
          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-6">
            <div className="section_title text_left mb-40 mt-3">
              
              <div className="section_main_title text-left">
                <h1>Why It Matters</h1>
              </div>
              <div className="em_bar">
                <div className="em_bar_bg"></div>
              </div>
             
            </div>

            <div className="singel_about_left mb-30">
              <div className="singel_about_left_inner mb-3">
                <div className="singel-about-content text-left">
               
                 <p>This assessment shows the real state of your GTM across marketing, sales, and revenue. It highlights gaps, priorities, and what to fix first, based on how your teams actually work today.</p>
                 <p>Your results depend on your answers, so honest inputs lead to practical guidance, not generic advice. The questions focus on data quality, targeting, pipeline discipline, and sales alignment.</p>
                 <p>At the end, you’ll receive a detailed report with your scores, risks you might be missing, and clear next steps to improve pipeline quality and conversions.</p>
                  <div className="singel_about_left_inner">
      
    </div>
                </div>
               
              </div>
             
              
            </div>
           
          </div>
         
        </div>
      </div>
    </div>
  );
}
